import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GREEN_YELLOW,
    codeProp: 'dtoUserCode',
    detailIdProp: 'dtoId',
    detailUrl: '/DtoDetail',
    listUrl: '/DtoList',
    mapProp: 'dtoMap',
    name: 'DTO',
    textProp: 'dtoName',
    type: 'DTO',
}
